// extracted by mini-css-extract-plugin
export default {"container":"Clipboard_container__7ypIg","slideIn":"Clipboard_slideIn__+fUjx","content":"Clipboard_content__KyzQ2"};